import React from 'react';
import PropTypes from 'prop-types';

const TrendEmpty = ({ className, style }) => {
  return (
    <svg width="19px" height="11px" viewBox="0 0 19 11" version="1.1" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
      <defs>
        <filter x="-3.0%" y="-2.3%" width="105.9%" height="104.5%" filterUnits="objectBoundingBox" id="filter-1">
          <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.68627451   0 0 0 0 0.756862745   0 0 0 0 0.882352941  0 0 0 1 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="dashboard-contract-rev2" transform="translate(-1156.000000, -646.000000)" fill="#7D7F83" fillRule="nonzero">
          <g id="Organism/Stats-Block" filter="url(#filter-1)" transform="translate(937.000000, 410.000000)">
            <g id="Molecule/Stats/Stats+Titles" transform="translate(23.000000, 15.000000)">
              <rect id="Rectangle" x="200" y="223" width="11" height="3" rx="1.5"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

TrendEmpty.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default TrendEmpty;
